import React from 'react';
import Typography from './StyledTypography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { PRIMARY_COLOR } from '../constants';
import mapMarkerImage from '../../../../images/features/saga/map_marker.png';
import AreaImages from './AreaImages';
import Grid from '@material-ui/core/Grid';
import AreaTitle from './AreaTitle';

export type AreaImageProps = {
  src: string,
  title: string,
};

type AreaProps = {
  number: string,
  area: string,
  city: string,
  description: React.ReactNode,
  images: Array<AreaImageProps>,
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(5),
  },
  content: {
    background: 'white',
    padding: theme.spacing(3),
  },
  placeContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  markerIcon: {
    width: 20,
  },
  place: {
    color: PRIMARY_COLOR,
    marginLeft: theme.spacing(2),
  },
  text: {
    marginBottom: theme.spacing(2),
  },
  imagesContainer: {
    display: 'flex',
    margin: theme.spacing(0, 0, 2),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0, 0, 2, 4),
    },
  },
}));

const Area = ({ number, area, city, description, images }: AreaProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h3>
        <AreaTitle number={number} area={area} />
      </h3>
      <div className={classes.content}>
        <div className={classes.placeContainer}>
          <img src={mapMarkerImage} alt="" className={classes.markerIcon} />
          <Typography className={classes.place}>{city}</Typography>
        </div>
        <Grid container>
          <Grid item xs={12} sm={6} md={8} className={classes.text}>
            {description}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <div className={classes.imagesContainer}>
              <AreaImages images={images} number={number} area={area} />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Area;
